import { useEffect, useState } from 'react';
import { Network } from '@kattana-io/common';
import { getCDNIcon } from '../../../helpers/coinIcon';
import IconProvider from '../../../helpers/IconProvider';
import NetworkBaseCoinIcon from '../../ConnectedWallet/NetworkBaseCoin';
import useIcon from '../../../molecules/PairIcons/useIcon';
import CoinPlaceholder from '../../../molecules/PairIcons/icons/placeholder.svg';
import { BASE_TOKEN } from '../helpers/nativeCoins';

type ISize = '16px' | '24px';

const getSrcForIcon = (
  contract: string,
  network: Network,
  currency: string
) => {
  if (contract) {
    return IconProvider.createFromNetworkAndPair(network, contract).url();
  }

  return getCDNIcon(currency);
};

interface ISmallCurrencyIconProps {
  network: Network;
  currency: string;
  contract: string;
  className?: string;
  variant: 's' | 'm';
}

/**
 * If we have an icon than try to load it
 * @returns
 */
const SmallCurrencyIcon = ({
  network,
  currency,
  contract,
  className,
  variant,
}: ISmallCurrencyIconProps) => {
  const [error, setError] = useState(false);

  const size: ISize = variant == 's' ? '16px' : '24px';
  const isBase = contract === BASE_TOKEN;

  const motherTokenStyle = {
    width: size,
    height: size,
    borderRadius: '50%',
  };

  const iconSrc = getSrcForIcon(contract, network, currency);

  useEffect(() => {
    setError(false);
  }, [iconSrc]);

  const path = useIcon(iconSrc, error, !!iconSrc && !isBase);

  if (isBase) {
    return (
      <NetworkBaseCoinIcon
        network={network}
        className={className || ''}
        motherTokenStyle={motherTokenStyle}
      />
    );
  }

  return path ? (
    <img
      className={`currency__icon ${className ? className : ''}`}
      src={error ? CoinPlaceholder : path}
      onError={() => setError(true)}
      style={motherTokenStyle}
    />
  ) : null;
};

export default SmallCurrencyIcon;
